/* global reviews, POWERREVIEWS */
/* eslint-disable camelcase */
var reviewsToRender = [];
function toBoolean(value) {
    if (typeof value === 'string') {
        value = value.toLowerCase();
    }
    if (value === 'true') {
        value = true;
    } else if (value === 'false') {
        value = false;
    }
    return value;
}

function renderReviews($control) {
    var pageId = $control.data('pageid'),
        controlId = $control.attr('id'),
        components = {};

    var review = {
        locale: reviews.locale,
        merchant_group_id: reviews.merchantGroupId,
        merchant_id: reviews.merchantId,
        api_key: reviews.apiKey,
        page_id: pageId,
        components: components
    };

    var reviewType = $control.data('reviewtype');
    switch (reviewType) {
        case 'ReviewForm':
            components.Write = controlId;
            POWERREVIEWS.display.render(review);
            break;
        case 'Category':
            components.CategorySnippet = controlId;
            reviewsToRender.push(review);
            break;
        case 'ReviewDisplay':
            components.ReviewDisplay = controlId;
            review.REVIEW_DISPLAY_SNAPSHOT_TYPE = 'SIMPLE';
            reviewsToRender.push(review);
            break;
        case 'Review':
            components.ReviewSnippet = controlId;
            reviewsToRender.push(review);
            break;
    }
}
function checkReviewByPageId($control, reviewtype) {
    var pageId = $control.data('pageid'),
        controlId = $control.attr('id'),
        reviewFound = false;
    $(reviewsToRender).each(function (index, currentReview) {
        if (!reviewFound) {
            if (
                currentReview.page_id === pageId &&
                (currentReview.components.ReviewSnippet ||
                    currentReview.components.ReviewDisplay)
            ) {
                if (reviewtype === 'Review') {
                    currentReview.components.ReviewSnippet = controlId;
                } else if (reviewtype === 'ReviewDisplay') {
                    currentReview.components.ReviewDisplay = controlId;
                    currentReview.REVIEW_DISPLAY_SNAPSHOT_TYPE = 'SIMPLE';
                }
                reviewFound = true;
            }
        }
    });
    if (!reviewFound) {
        renderReviews($control);
    }
}

function setupTracking($control) {
    var pageId = String($control.data('pageid')),
        sampleItemNames = $control.data('sampleitemname').split('|'),
        tracker = POWERREVIEWS.tracker.createTracker({
            merchantGroupId: reviews.merchantGroupId
        });
    var orderItems = [];
    $(pageId.split(',')).each(function (index, text) {
        var orderItem = {
            page_id: text,
            product_name:
                sampleItemNames.length > index ? sampleItemNames[index] : '',
            quantity: 1,
            unit_price: 1.0
        };

        orderItems.push(orderItem);
    });

    var orderFeed = {
        merchantGroupId: reviews.merchantGroupId,
        merchantId: reviews.merchantId,
        locale: reviews.locale,
        marketingOptIn: toBoolean($control.data('futureoptin')),
        userEmail: $control.data('email'),
        merchantUserId: $control.data('email'),
        userFirstName: $control.data('firstname') || '',
        userLastName: $control.data('lastname'),
        orderId: $control.data('orderid'),
        orderItems: orderItems
    };

    tracker.trackCheckout(orderFeed);
}
function setUpRatingsandReviews() {
    try {
        reviewsToRender.length = 0;
        var $controls = $('.js-review');
        if ($controls.length > 0) {
            $controls.each(function () {
                var $control = $(this);

                var reviewType = $control.data('reviewtype');
                switch (reviewType) {
                    case 'CheckoutBeacon':
                        setupTracking($control);
                        break;
                    case 'Category':
                    case 'ReviewForm':
                        renderReviews($control);
                        break;

                    case 'ReviewDisplay':
                    case 'Review':
                        checkReviewByPageId($control, reviewType);
                        break;
                }
            });

            if (reviewsToRender.length > 0) {
                POWERREVIEWS.display.render(reviewsToRender);
              }

        }
    } catch (e) {
        window.console && window.console.error && window.console.error(e);
    }
}
(function ($) {
    setUpRatingsandReviews();
})(jQuery);